import { Video } from "@rootreeweb/ui";

import image from "@/assets/holiday-cards/holiday-card-yoga-tutorials.png";
import { DayDefinition } from "../DayDefinition.js";

/** Class Yoga_Tutorials Represents the Yoga Tutorials card. */
export class Yoga_Tutorials extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-darkbrown2022";

	public image = image;

	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "yoga-tutorials";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Yoga Tutorials";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`The best way to fight the winter’s cold Is through inhaling and exhaling with each stretch and fold
					Join our Director of HR for an in-home yoga session
					You might just find yoga is your favourite new obsession`}
				</p>
				<div className="hl:flex hl:flex-col hl:gap-4">
					<Video
						image="https://rootree.ca/wp-content/uploads/2022/12/full-body-flow.png"
						title="Yoga Tutorials"
						video="SV3D_FzHyi8"
					/>
					<Video
						image="https://rootree.ca/wp-content/uploads/2022/12/shoulder-mobility.png"
						title="Yoga Tutorials"
						video="K57uKb1L71g"
					/>
					<Video
						image="https://rootree.ca/wp-content/uploads/2022/12/core-strengthening.png"
						title="Yoga Tutorials"
						video="2En8bZhQkjQ"
					/>
				</div>
			</>
		);
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Les Tutos Yoga";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`La meilleure façon de combattre le froid hivernal c’est de s’étirer en prenant le temps d’inspirer et d’expirer profondément.
					Retrouvez notre directeur des ressources humaines pour une séance de yoga à domicile et faites-en votre nouveau passe-temps favori !`}
				</p>
				<div className="hl:flex hl:flex-col hl:gap-4">
					<Video
						image="https://rootree.ca/wp-content/uploads/2022/12/full-body-flow.png"
						title="Les Tutos Yoga"
						video="SV3D_FzHyi8"
					/>
					<Video
						image="https://rootree.ca/wp-content/uploads/2022/12/shoulder-mobility.png"
						title="Les Tutos Yoga"
						video="K57uKb1L71g"
					/>
					<Video
						image="https://rootree.ca/wp-content/uploads/2022/12/core-strengthening.png"
						title="Les Tutos Yoga"
						video="2En8bZhQkjQ"
					/>
				</div>
			</>
		);
	}
}
